import type { SVGProps } from 'react';
export const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={21}
		height={21}
		fill="none"
		viewBox="0 0 21 21"
		{...props}
	>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12.992 15.083h1.258a4.597 4.597 0 0 0 4.583-4.584 4.597 4.597 0 0 0-4.583-4.583h-1.258M8 5.916H6.75a4.59 4.59 0 0 0-4.583 4.583 4.597 4.597 0 0 0 4.583 4.584H8M7.167 10.5h6.666"
		/>
	</svg>
);
